import React, { Fragment, useEffect, useState } from "react";
import Link from "react-router-dom/Link";
import $, { post } from "jquery";
import connect from "react-redux/lib/connect/connect";
import {
  dateFormation,
  getGameLaunch,
  getGameList,
  getImages,
  getlistImgPath,
  getLobbylist,
  getLoginLobbylist,
  getTitle,
  isEmpty,
  isMobilePage,
  toastr,
} from "../../common/cores";
import MobileVisual from "../../components/common/MobileVisaul";
import PCVisual from "../../components/common/PCVisaul";
import {
  GetDepositList,
  GetEventList,
  GetLoginNoticeList,
  GetNoticeList,
  GetRealTimeExchangeData,
  GetWithDrawList,
} from "../../common/actions/moreAction";
import { SetPageInfo, SetPageLoading } from "../../common/actions/pageAction";
import {
  GetDashboardSportsList,
  GetSportsList,
} from "../../common/actions/sportsAction";
import Headbar from "../../components/Layout/Headbar";
import Footbar, { MobileFootbar } from "../../components/Layout/Footbar";
import { resource_url } from "../../common/cores/keys";
import { interleaveArrays, isMobile } from "../../utils/utils";
import OneRowTablePicker from "./OneRowTablePicker";
// import { visual } from "../../utils";
const Menus = [
  {
    name: "라이브카지노",
    Ename: "Live Casino",
    path: "/casino",
    img: "../images/main_game01.png",
  },
  {
    name: "슬롯게임",
    Ename: "Slot Game",
    path: "/slot",
    img: "../images/main_game02.png",
  },
  {
    name: "스포츠",
    Ename: "Sports",
    path: "/sportsprematch",
    img: "../images/main_game03.png",
  },
  {
    name: "미니게임",
    Ename: "Mini Game",
    path: "/minigame",
    img: "../images/main_game04.png",
  },
];

const Dashboard = (props) => {
  const { isAuthenticated, user, unreadNotes, casinoStatus, notices, more } =
    props;
  // const isAuthenticated  = props.user.isAuthenticated;
  const roomObj = {
    pageType: "toto",
    sportType: "sport",
    gameType: "live",
    sportId: "all",
    esportType: "all",
    sort: "time",
    location: "all",
    page: 1,
    perPage: 10,
  };

  const [casinoLists, setCasinoLists] = useState([]);
  const [slotLists, setSlotLists] = useState([]);
  const [bestGameList, setBestGameList] = useState([]);

  const [showCasinos, setShowCasinos] = useState([]);
  const [showSlots, setShowSlots] = useState([]);
  const [showBestGames, setShowBestGames] = useState([]);

  const [gameLists, setGameLists] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [imgLists, setImgLists] = useState([]);
  const [showAllCasino, setShowAllCasino] = useState(false);
  const [showAllSlot, setShowAllSlot] = useState(false);
  const [showAllBestGame, setShowAllBestGame] = useState(false);
  const [search, setSearch] = useState("");
  const [eventType, setEventType] = useState("");

  const headerStyle = {
    position: "relative",
    top: "0px",
    left: "0px",
    width: "400px",
    height: "85px", // `!important`는 적용 불가
    boxShadow: "1px 5px 10px #0c0c0c",
    zIndex: "10", // 마지막 선언만 유지
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.20) 20%, rgba(0, 0, 0, 0.95) 50%, rgba(0, 0, 0, 0.3) 56%)",
    backgroundColor: "#333",
    borderTop: "1px solid #6a6a6a",
    borderBottom: "1px solid #6a6a6a",
    borderRadius: "4px",
  };

  const normalStyle = {
    height: "40px",
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setSearch(value);
  };

  const normalImage = "Logo.jpg";
  const gameType = "Slot";

  const onClickOpenModal = (list) => {
    if (!props.isAuthenticated)
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    props.SetPageLoading(true);
    setGameLists([]);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      vendor: list.vendor,
      // api: api
    };

    getGameList(params).then((data) => {
      // setApi(data.api);
      getImages(data.result, data.api).then((images) => {
        setImgLists(images);
        setGameLists(data.result);
        setOpenModal(!openModal);
        props.SetPageLoading(false);
      });
    });
  };

  const onClickList = (list) => {
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  const posts = more.event.posts;

  useEffect(() => {}, [eventType]);

  const onClickCloseModal = (list) => {
    // console.log(list);
    setOpenModal(!openModal);
  };

  const getModalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  const getLists = (type) => {
    const params = {
      type: type,
    };
    getLoginLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
    });
  };

  const getLoginLists = (type) => {
    props.SetPageLoading(true);
    const params = {
      type: type,
      token: user.loginId,
      username: user.loginId,
      status: casinoStatus,
    };
    getLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
      props.SetPageLoading(false);
    });
  };

  const onClickCasino = (list, event) => {
    event.preventDefault();
    if (!isAuthenticated) {
      toastr.warning(
        isEmpty(window.lang["로그인하시고 이용해주세요."])
          ? "로그인하시고 이용해주세요."
          : window.lang["로그인하시고 이용해주세요."]
      );
      return;
    }
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: "casino",
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  useEffect(() => {
    if (showAllCasino == false) {
      setShowCasinos(casinoLists.slice(0, 6));
    } else {
      setShowCasinos(casinoLists);
    }
  }, [showAllCasino, casinoLists]);

  useEffect(() => {
    if (showAllSlot == false) {
      setShowSlots(slotLists.slice(0, 6));
    } else {
      setShowSlots(slotLists);
    }
  }, [showAllSlot, slotLists]);

  useEffect(() => {
    if (showAllBestGame == false) {
      setShowBestGames(slotLists.slice(0, 6));
    } else {
      setShowBestGames(slotLists);
    }
  }, [showAllBestGame, slotLists]);

  let gamelists = [],
    depositlists = [],
    withdrawlists = [];

  gamelists = props.sports.data;

  depositlists = props.more.realDeposite.data;
  withdrawlists = props.more.realWithdraw.data;

  useEffect(() => {
    const roomObj = {
      pageType: "toto",
      sportType: "sport",
      gameType: "live",
      sportId: "all",
      esportType: "all",
      sort: "time",
      location: "all",
      page: 1,
      perPage: 10,
    };

    props.GetDashboardSportsList(roomObj);

    if (props.user.isAuthenticated) getLists(1);
    new window.Swiper({
      el: ".main_best_list",
      slidesPerView: 5, //레이아웃 뷰 개수
      spaceBetween: 25, // 슬라이드 사이 여백
      centeredSlides: true, //센터모드
      loop: true, // 슬라이드 반복 여부
      autoplay: true,
      loopAdditionalSlides: 1, // 슬라이드 반복 시 마지막 슬라이드에서 다음 슬라이드가 보여지지 않는 현상 수정
      slideToClickedSlide: true, // 해당 슬라이드 클릭시 슬라이드 위치로 이동
      initialSlide: 0,
      grabCursor: false,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      mousewheel: {
        enabled: false,
      },
      keyboard: {
        enabled: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // 1024: {
        //     slidesPerView: 5
        // },
        // 520: {
        //     slidesPerView: 1
        // }
      },
    });
  }, []);

  const [day, setDay] = useState("");

  const getDay = () => {
    setInterval(() => {
      let time = new Date();
      setDay(dateFormation(time));
    }, 1000);
  };
  // useEffect(()=>{
  //     getDay();
  // });

  useEffect(() => {
    // visual();
    let time = new Date();
    // setDay( dateFormation(time));
    $("#slide_time").html(dateFormation(time));
    setInterval(() => {
      let time = new Date();
      // setDay( dateFormation(time));
      $("#slide_time").html(dateFormation(time));
    }, 1000);
  }, []);

  useEffect(() => {
    if (window.$) {
      // Initialize the tableTicker plugin when the component mounts
      // $(window).on("load", () => {
      console.log("testestsetes");

      window.$(".myTable").tableTicker({
        row: 8, //몇줄 롤링?
        speed: 1000, //롤링 속도 1000 = 1초에 애니메이션 종료
        interval: 2000, //정지 기간 (1000 = 1초, 0 = 논스탑)
        buffer: 0, // 이동폭 및 높이 보정용 추가 픽셀 (마이너스 값은 입력 불가)
        complete: null, // 매 롤링 후 호출되는 callback function
      });
      window.$("#myTable3").tableTicker({
        row: 2,
        speed: 2000,
        interval: 2000,
        buffer: 0,
        complete: function () {
          $("#cnt").html(this.rolled);
        },
      });
      // });
    }
  }, [props.user.isAuthenticated]);

  useEffect(() => {
    props.GetRealTimeExchangeData(1);
    props.GetRealTimeExchangeData(-1);

    const depositeInterval = setInterval(
      props.GetRealTimeExchangeData(1),
      150000
    );
    const withdrawInterval = setInterval(
      props.GetRealTimeExchangeData(-1),
      150000
    );

    return () => {
      clearInterval(depositeInterval);
      clearInterval(withdrawInterval);
    };
  }, []);

  useEffect(() => {
    props.GetEventList({ page: 1, perPage: 10, type: "" });
    if (isAuthenticated) {
      getLoginLists("casino");
      props.GetNoticeList({ page: 1, perPage: 10 });
      getLoginLists("Slot");
    } else {
      getLists("casino");
      props.GetLoginNoticeList({ page: 1, perPage: 10 });
      getLists("Slot");
    }
  }, [isAuthenticated]);

  const onClickMemMenu = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  const onClickImg = (e, url) => {
    if (!isAuthenticated) {
      e.preventDefault();
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
    window.location.href = url;
  };

  return (
    <Fragment>
      {isMobile() ? (
        <MobileDashboard {...props} />
      ) : (
        <Fragment>
          <div id="layoutBody" style={{ paddingTop: "0px" }}>
            <div className="wrapper  lang_ko" id="bodyTemplate">
              <div id="contentTheme"></div>
              <Headbar />
              <div className="container-fluid main_section">
                <div className="main_visual">
                  <div className="notice_area">
                    <div className="inner">
                      <p className="tit">
                        {" "}
                        <img
                          src="/r/front/img/main/txt_notice.jpg"
                          alt="notice"
                        />
                        <span
                          className=""
                          langkey="new_theme.common.notification"
                        >
                          {isEmpty(window.lang["공지"])
                            ? "공지"
                            : window.lang["공지"]}
                        </span>{" "}
                      </p>
                      <div className="marquee">
                        <div>
                          <p
                            className="txt"
                            id="lineMsg"
                            style={{ color: "rgb(255, 255, 255)" }}
                          >
                            {isEmpty(
                              window.lang[
                                "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                              ]
                            )
                              ? "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                              : window.lang[
                                  "안녕하세요 오늘도 찾아주셔서 감사합니다.오늘도 고객님의 행운을 기원 합니다.!!"
                                ]}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="theme_banner_outer">
                  <div
                    id="theme_banner_check"
                    style={{ visibility: "visible" }}
                  >
                    <div
                      className="swiper-container snb_sl swiper-container-initialized swiper-container-horizontal"
                      id="swiper-head0"
                    >
                      <div
                        id="demo"
                        className="carousel slide"
                        data-ride="carousel"
                      >
                        <ul className="carousel-indicators">
                          <li
                            data-target="#demo"
                            data-slide-to="0"
                            className="active"
                          ></li>
                          <li data-target="#demo" data-slide-to="1"></li>
                          <li data-target="#demo" data-slide-to="2"></li>
                          <li data-target="#demo" data-slide-to="3"></li>
                          <li data-target="#demo" data-slide-to="4"></li>
                          <li data-target="#demo" data-slide-to="4"></li>
                        </ul>

                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <img
                              src="../images/banners/pc/1.webp"
                              alt="Chicago"
                              className=""
                              data-seq="1883"
                              onClick={(e) => onClickImg(e, "/casino")}
                            />
                          </div>
                          <div className="carousel-item">
                            <img
                              src="../images/banners/pc/2.webp"
                              alt="Chicago"
                              className=""
                              onClick={(e) => onClickImg(e, "/sportslive")}
                            />
                          </div>
                          <div className="carousel-item">
                            <img
                              src="../images/banners/pc/3.webp"
                              alt="New York"
                              className=""
                              onClick={(e) => onClickImg(e, "/Slot")}
                            />
                          </div>
                          <div className="carousel-item">
                            <img
                              src="../images/banners/pc/4.webp"
                              alt="New York"
                              className=""
                              onClick={(e) => onClickImg(e, "/sportsprematch")}
                            />
                          </div>
                          <div className="carousel-item">
                            <img
                              src="../images/banners/pc/5.webp"
                              alt="New York"
                              className=""
                              onClick={(e) => onClickImg(e, "/minigame")}
                            />
                          </div>
                        </div>

                        <a href="#demo" data-slide="prev">
                          <div
                            className="swiper-button-prev"
                            role="button"
                            aria-label="Previous slide"
                          ></div>
                        </a>
                        <a href="#demo" data-slide="next">
                          <div
                            className="swiper-button-next"
                            role="button"
                            aria-label="Next slide"
                          ></div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contents">
                  <div className="quick-main">
                    <ul>
                      <li className="sports">
                        <a data-href="/game/newDetail/0?gamecode=66&amp;game_child_seq=13143&amp;event=N&amp;type=sports">
                          <img
                            src="/r/theme/center_logo/img/pc/img_main_q_sports.png"
                            alt="스포츠"
                          />
                        </a>
                      </li>
                      <li className="casino">
                        <a data-href="/game/main/10588">
                          <img
                            src="/r/theme/center_logo/img/pc/img_main_q_casino.png"
                            alt="카지노"
                          />
                        </a>
                      </li>
                      <li className="evolution">
                        <a data-href="/game/casino/detail/0?gamecode=12&amp;game_child_seq=18403&amp;event=N">
                          <img
                            src="/r/theme/center_logo/img/pc/img_main_q_evolution.png"
                            alt="에볼루션"
                          />
                        </a>
                      </li>
                      <li className="minigame">
                        <a data-href="/game/newDetail/0?gamecode=71021&amp;game_child_seq=21366">
                          <img
                            src="/r/theme/center_logo/img/pc/img_main_q_minigame.png"
                            alt="미니게임"
                          />
                        </a>
                      </li>
                      <li className="slot">
                        <a data-href="/game/main/10558">
                          <img
                            src="/r/theme/center_logo/img/pc/img_main_q_slotgame.png"
                            alt="슬롯"
                          />
                        </a>
                      </li>
                      <li className="event">
                        <a>
                          <img
                            src="/r/theme/center_logo/img/pc/img_main_q_event.png"
                            alt="이벤트"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="status" id="theme_main_status">
                    <div
                      className="notice greybox"
                      style={{ maxHeight: "calc(100% - 60px)" }}
                    >
                      <p
                        className="boxtit"
                        langkey="title.dashboard.notice.main"
                      >
                        {isEmpty(window.lang["공지"])
                          ? "공지"
                          : window.lang["공지"]}
                      </p>{" "}
                      <Link
                        className="bt_more"
                        to="/notices"
                        onClick={onClickMemMenu}
                      >
                        +{" "}
                        <span className="" langkey="button.more">
                          {isEmpty(window.lang["더보기"])
                            ? "더보기"
                            : window.lang["더보기"]}
                        </span>
                      </Link>
                      <div className="list_wrap">
                        <table className="noti_list">
                          <tbody id="noticeList">
                            {notices.map((list, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {" "}
                                    <a className="title d-inline-block">
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: list.title,
                                        }}
                                      ></span>
                                    </a>{" "}
                                  </td>
                                  <td className="date">
                                    {dateFormation(list.created_date, 3)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="realtime greybox">
                      <div
                        style={{
                          height: "calc(100% - 20px)",
                          overflow: "hidden",
                          maxHeight: "calc(100vh - 200px)",
                        }}
                      >
                        <p className="boxtit">
                          <span className="" langkey="col.withdraw_live">
                            {isEmpty(window.lang["실시간 입금 현황"])
                              ? "실시간 입금 현황"
                              : window.lang["실시간 입금 현황"]}
                          </span>
                        </p>
                        <table
                          width="100%"
                          border="0"
                          cellSpacing="0"
                          cellPadding="0"
                          className="myTable"
                          style={{ maxHeight: 300 }}
                        >
                          <tbody>
                            {withdrawlists.map((list, index) => {
                              return (
                                <Fragment key={index}>
                                  <tr
                                    className="swiper-slide swiper-slide-active on swiperOn"
                                    style={{ height: "40px" }}
                                  >
                                    <td
                                      style={{ paddingLeft: "20px" }}
                                      className="board_time"
                                    >
                                      <span className="board_font1">
                                        {dateFormation(list.created_date, 11)}
                                      </span>{" "}
                                    </td>
                                    <td
                                      align="right"
                                      style={{ paddingRight: "20px" }}
                                      className="board_user"
                                    >
                                      <span className="board_font2">
                                        {list.userid}
                                      </span>
                                    </td>
                                    <td
                                      align="right"
                                      style={{ paddingRight: "20px" }}
                                      className="board_money"
                                    >
                                      ￦{Number(list.amount).toLocaleString()}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="realtime greybox">
                      <div
                        style={{
                          height: "calc(100% - 20px)",
                          overflow: "hidden",
                          maxHeight: "calc(100vh - 200px)",
                        }}
                      >
                        <p className="boxtit">
                          <span className="" langkey="col.withdraw_live">
                            {isEmpty(window.lang["실시간 출금 현황"])
                              ? "실시간 출금 현황"
                              : window.lang["실시간 출금 현황"]}
                          </span>
                        </p>
                        <table
                          width="100%"
                          border="0"
                          cellSpacing="0"
                          cellPadding="0"
                          className="myTable"
                        >
                          <tbody>
                            {depositlists.map((list, index) => {
                              return (
                                <Fragment key={index}>
                                  <tr
                                    className="swiper-slide swiper-slide-active on swiperOn board_time"
                                    style={{ height: "40px" }}
                                  >
                                    <td style={{ paddingLeft: "30px" }}>
                                      <span className="board_font1">
                                        {dateFormation(list.created_date, 11)}
                                      </span>{" "}
                                    </td>
                                    <td
                                      align="right"
                                      style={{ paddingRight: "20px" }}
                                      className="board_user"
                                    >
                                      <span className="board_font2">
                                        {list.userid}
                                      </span>
                                    </td>
                                    <td
                                      align="right"
                                      style={{ paddingRight: "30px" }}
                                      className="board_money"
                                    >
                                      ￦{Number(list.amount).toLocaleString()}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {/* <div className="jackpot greybox">
                  <p className="boxtit"><span className="" langkey="col.jackpot">잭팟 당첨자 현황</span></p>
                  <div className="jackpot swiper-container swiper-container-initialized swiper-container-vertical"
                    id="swiper-jackpot">
                    <ul className="jackpot_list swiper-wrapper" id="jackpotList"
                      style={{ transform: 'translate3d(0px, 0px, 0px)', transitionDuration: '600ms' }}>
                      <li className="swiper-slide swiper-slide-active on swiperOn"
                        style={{ height: 'auto', marginTop: '0px', marginBottom: '5px' }}> <a className="moveGameUrl">
                          <div className="normal">
                            <p className="name">오동통</p>
                            <p className="game">레프리콘 리치</p>
                            <p className="money add-commas">1,000원</p> <span className="thumb"> <img
                              src="../images/upload/2020/0713/2C6BC114_842C_4493_B348_02FA56095353.png?104x104c"
                              alt="" /> </span>
                          </div>
                          <div className="hoverbox"> <span className="img_money"></span>
                            <p className="name">오동통</p>
                            <p className="game">레프리콘 리치</p>
                            <p className="money_odd add-commas">1,000원</p>
                            <p className="money_odd1 add-commas">1,420.000</p> <span className="edge"></span>
                            <span className="thumb"> <img
                              src="../images/upload/2020/0713/2C6BC114_842C_4493_B348_02FA56095353.png?104x104c"
                              alt="" /> </span>
                          </div>
                        </a> </li>
                      <li className="swiper-slide swiper-slide-next"
                        style={{ height: '33px', marginTop: '0px', marginBottom: '5px' }}> <a className="moveGameUrl">
                          <div className="normal">
                            <p className="name">돈땃다</p>
                            <p className="game">스보벳</p>
                            <p className="money add-commas">20,000,000원</p> <span className="thumb"> <img
                              src="../images/upload/2024/0131/T6Rq_Kfp9_4FHO_kgRS.png?104x104c"
                              alt="" /> </span>
                          </div>
                          <div className="hoverbox"> <span className="img_money"></span>
                            <p className="name">돈땃다</p>
                            <p className="game">스보벳</p>
                            <p className="money_odd add-commas">20,000,000원</p>
                            <p className="money_odd1 add-commas">2.100</p> <span className="edge"></span> <span
                              className="thumb"> <img
                                src="../images/upload/2024/0131/T6Rq_Kfp9_4FHO_kgRS.png?104x104c"
                                alt="" /> </span>
                          </div>
                        </a> </li>
                      <li className="swiper-slide" style={{ height: '33px', marginTop: '0px', marginBottom: '-10px' }}>
                        <a className="moveGameUrl">
                          <div className="normal">
                            <p className="name">test1</p>
                            <p className="game">10벳</p>
                            <p className="money add-commas">100,000원</p> <span className="thumb"> <img
                              src="../images/upload/2024/0131/u89B_zyQn_8c5J_Jqgq.png?104x104c"
                              alt="" /> </span>
                          </div>
                          <div className="hoverbox"> <span className="img_money"></span>
                            <p className="name">test1</p>
                            <p className="game">10벳</p>
                            <p className="money_odd add-commas">100,000원</p>
                            <p className="money_odd1 add-commas">2,354.000</p> <span className="edge"></span>
                            <span className="thumb"> <img
                              src="../images/upload/2024/0131/u89B_zyQn_8c5J_Jqgq.png?104x104c"
                              alt="" /> </span>
                          </div>
                        </a> </li>
                      <li className="swiper-slide" style={{ height: '33px', marginTop: '0px', marginBottom: '5px' }}> <a
                        className="moveGameUrl">
                        <div className="normal">
                          <p className="name">test</p>
                          <p className="game">야구</p>
                          <p className="money add-commas">50,000원</p> <span className="thumb"> <img
                            src="../images/upload/2022/1220/jCUg_iGir_zspX_jy0q.png?104x104c"
                            alt="" /> </span>
                        </div>
                        <div className="hoverbox"> <span className="img_money"></span>
                          <p className="name">test</p>
                          <p className="game">야구</p>
                          <p className="money_odd add-commas">50,000원</p> <span className="edge"></span> <span
                            className="thumb"> <img
                              src="../images/upload/2022/1220/jCUg_iGir_zspX_jy0q.png?104x104c"
                              alt="" /> </span>
                        </div>
                      </a> </li>
                    </ul> <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                  </div>
                </div> */}
                  </div>
                  <div id="gameList">
                    <div className="game_list1" id="category2289">
                      <div className="sport inner">
                        <div className="titlebox">
                          <h4>
                            {isEmpty(window.lang["라이브카지노"])
                              ? "라이브카지노"
                              : window.lang["라이브카지노"]}{" "}
                          </h4>
                          <a
                            className="bt_all pointer simple  "
                            id="bt_all_2289"
                            data-category-seq="category2289"
                            data-seq="0"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            +&nbsp;&nbsp;&nbsp;{" "}
                            <span
                              className=""
                              langkey="desc.all_view"
                              onClick={() => {
                                setShowAllCasino(!showAllCasino);
                              }}
                            >
                              {showAllCasino
                                ? isEmpty(window.lang["간편보기"])
                                  ? "간편보기"
                                  : window.lang["간편보기"]
                                : isEmpty(window.lang["모두보기"])
                                ? "모두보기"
                                : window.lang["모두보기"]}
                            </span>
                          </a>
                        </div>
                        <div className="game_list_wrap" data-cat="2289">
                          <ul className="row">
                            {showCasinos.map((list, index) => {
                              return (
                                <li
                                  className="col-6 col-md-2 col-sm-3"
                                  key={index}
                                  data-move-url="/game/casino/detail/0?gamecode=12&amp;game_child_seq=3602&amp;event=N"
                                  data-game-title="코리안 딜러 스피드 바카라"
                                  data-game-title-en="Korean Speed Baccarat"
                                  data-game-code="12"
                                  data-game-meta-code="npn3y3hkld2mcdjt"
                                  data-game-description="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  data-game-video-url="c309b3d6f89ecc3395a96a02ca12a60e"
                                  data-event_game_yn="N"
                                  data-game-child-seq="3602"
                                  onClick={(e) => {
                                    onClickCasino(list, e);
                                  }}
                                >
                                  {" "}
                                  <span className="G005001"></span>{" "}
                                  <img
                                    className="videoPosterImages"
                                    video-seq="0"
                                    data-original="/upload/2021/0823/L6tP_zGpX_DGVE_qwOf.png?306x306c"
                                    style={{
                                      width: "100%",
                                      // height: "150px",
                                      objectFit: "cover",
                                    }}
                                    src={getlistImgPath(list)}
                                  />
                                  <div className="gameInfo">
                                    <p className="gameTitle">
                                      {" "}
                                      {getTitle(list, props.language)}{" "}
                                    </p>{" "}
                                    <span
                                      className="gameDetailInfo"
                                      data-game-name="코리안 딜러 스피드 바카라"
                                      data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                      langkey="col.reminders"
                                    >
                                      유의사항
                                    </span>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="game_list1" id="category1830">
                      <div className="sport inner">
                        <div className="titlebox">
                          <h4>
                            {isEmpty(window.lang["슬롯"])
                              ? "슬롯"
                              : window.lang["슬롯"]}{" "}
                          </h4>
                          <a
                            className="bt_all pointer simple  "
                            id="bt_all_1830"
                            data-category-seq="category1830"
                            data-seq="2"
                          >
                            +&nbsp;&nbsp;&nbsp;{" "}
                            <span
                              className=""
                              langkey="desc.all_view"
                              onClick={() => {
                                setShowAllSlot(!showAllSlot);
                              }}
                            >
                              {showAllSlot
                                ? isEmpty(window.lang["간편보기"])
                                  ? "간편보기"
                                  : window.lang["간편보기"]
                                : isEmpty(window.lang["모두보기"])
                                ? "모두보기"
                                : window.lang["모두보기"]}
                            </span>
                          </a>
                        </div>
                        <div className="game_list_wrap" data-cat="1830">
                          <ul className="row">
                            {showSlots.map((list, index) => {
                              return (
                                <li
                                  className="col-6 col-md-2 col-sm-3"
                                  key={index}
                                  data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-game-title="빅 배스 보난자"
                                  data-game-title-en="Big Bass Bonanza"
                                  data-game-code="28"
                                  data-game-meta-code="244"
                                  data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                                  data-game-video-url=""
                                  data-event_game_yn="N"
                                  data-game-child-seq="11605"
                                  onClick={() => onClickOpenModal(list)}
                                >
                                  {" "}
                                  <span className="G005001"></span>{" "}
                                  <img
                                    className="videoPosterImages"
                                    video-seq="0"
                                    data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                    style={{
                                      width: "100%",
                                      // height: "150px",
                                      objectFit: "cover",
                                    }}
                                    src={getlistImgPath(list)}
                                  />
                                  <div className="gameInfo">
                                    <p className="gameTitle">
                                      {" "}
                                      {getTitle(list, props.language)}{" "}
                                    </p>{" "}
                                    <span
                                      className="gameDetailInfo"
                                      data-game-name="빅 배스 보난자"
                                      data-game-detail="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                                      langkey="col.reminders"
                                    >
                                      유의사항
                                    </span>
                                  </div>
                                  <div
                                    className="layer_item_set"
                                    style={{
                                      top: "1px",
                                      left: "1px",
                                      display: "none",
                                    }}
                                  >
                                    <div className="thumb" id="test22">
                                      {" "}
                                      <a
                                        style={{
                                          background:
                                            "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                          backgroundSize: "100%",
                                        }}
                                      >
                                        <img
                                          src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                          style={{
                                            width: "218px",
                                            height: "218px",
                                          }}
                                          className="item_img"
                                        />{" "}
                                      </a>
                                    </div>
                                    <div
                                      className="gameLinkArea"
                                      data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                      data-new-window=""
                                    ></div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="game_list1" id="category1830">
                      <div className="sport inner">
                        <div className="titlebox">
                          <h4>
                            {isEmpty(window.lang["베스트게임"])
                              ? "베스트게임"
                              : window.lang["베스트게임"]}{" "}
                          </h4>
                          <a
                            className="bt_all pointer simple  "
                            id="bt_all_1830"
                            data-category-seq="category1830"
                            data-seq="2"
                          >
                            +&nbsp;&nbsp;&nbsp;{" "}
                            <span
                              className=""
                              langkey="desc.all_view"
                              onClick={() => {
                                setShowAllBestGame(!showAllBestGame);
                              }}
                            >
                              {showAllBestGame
                                ? isEmpty(window.lang["간편보기"])
                                  ? "간편보기"
                                  : window.lang["간편보기"]
                                : isEmpty(window.lang["모두보기"])
                                ? "모두보기"
                                : window.lang["모두보기"]}
                            </span>
                          </a>
                        </div>
                        <div className="game_list_wrap" data-cat="1830">
                          <ul className="row">
                            {showBestGames.map((list, index) => {
                              return (
                                <li
                                  className="col-6 col-md-2 col-sm-3"
                                  key={index}
                                  data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-game-title="빅 배스 보난자"
                                  data-game-title-en="Big Bass Bonanza"
                                  data-game-code="28"
                                  data-game-meta-code="244"
                                  data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                                  data-game-video-url=""
                                  data-event_game_yn="N"
                                  data-game-child-seq="11605"
                                  onClick={() => onClickOpenModal(list)}
                                >
                                  {" "}
                                  <span className="G005001"></span>{" "}
                                  <img
                                    className="videoPosterImages"
                                    video-seq="0"
                                    data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                    style={{
                                      width: "100%",
                                      // height: "150px",
                                      objectFit: "cover",
                                    }}
                                    src={getlistImgPath(list)}
                                  />
                                  <div className="gameInfo">
                                    <p className="gameTitle">
                                      {" "}
                                      {getTitle(list, props.language)}{" "}
                                    </p>{" "}
                                    <span
                                      className="gameDetailInfo"
                                      data-game-name="빅 배스 보난자"
                                      data-game-detail="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                                      langkey="col.reminders"
                                    >
                                      유의사항
                                    </span>
                                  </div>
                                  <div
                                    className="layer_item_set"
                                    style={{
                                      top: "1px",
                                      left: "1px",
                                      display: "none",
                                    }}
                                  >
                                    <div className="thumb" id="test22">
                                      {" "}
                                      <a
                                        style={{
                                          background:
                                            "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                          backgroundSize: "100%",
                                        }}
                                      >
                                        <img
                                          src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                          style={{
                                            width: "218px",
                                            height: "218px",
                                          }}
                                          className="item_img"
                                        />{" "}
                                      </a>
                                    </div>
                                    <div
                                      className="gameLinkArea"
                                      data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                      data-new-window=""
                                    ></div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mainEvent" id="mainEventArea">
                    <div id="theme_event">
                      <div className="inner">
                        <div className="titlebox addTab">
                          <h4 className="" langkey="new_theme.common.event">
                            {isEmpty(window.lang["이벤트"])
                              ? "이벤트"
                              : window.lang["이벤트"]}
                          </h4>
                          <div className="main_event_area">
                            <ul
                              className="tabMenus"
                              id="theme_event_tabMenus"
                              style={{
                                position: "absolute",
                                width: "614.688px",
                              }}
                            >
                              <li
                                className="wbcMain_clickAction"
                                key="1"
                                categoryno="0"
                                style={{
                                  borderBottom:
                                    eventType === "" ? "3px solid #fff" : "",
                                }}
                                onClick={() => {
                                  setEventType("");
                                }}
                              >
                                <a className="" langkey="new_theme.common.all">
                                  {isEmpty(window.lang["전체"])
                                    ? "전체"
                                    : window.lang["전체"]}
                                </a>
                              </li>
                              <li
                                className="wbcMain_clickAction"
                                key="2"
                                categoryno="42"
                                onClick={() => {
                                  setEventType("sports");
                                }}
                                style={{
                                  borderBottom:
                                    eventType === "sports"
                                      ? "3px solid #fff"
                                      : "",
                                }}
                              >
                                <a>
                                  {isEmpty(window.lang["스포츠"])
                                    ? "스포츠"
                                    : window.lang["스포츠"]}
                                </a>
                              </li>
                              <li
                                className="wbcMain_clickAction"
                                key="3"
                                categoryno="43"
                                onClick={() => {
                                  setEventType("casino");
                                }}
                                style={{
                                  borderBottom:
                                    eventType === "casino"
                                      ? "3px solid #fff"
                                      : "",
                                }}
                              >
                                <a>
                                  {isEmpty(window.lang["카지노"])
                                    ? "카지노"
                                    : window.lang["카지노"]}
                                </a>
                              </li>
                              <li
                                className="wbcMain_clickAction"
                                key="4"
                                categoryno="44"
                                onClick={() => {
                                  setEventType("Slot");
                                }}
                                style={{
                                  borderBottom:
                                    eventType === "Slot"
                                      ? "3px solid #fff"
                                      : "",
                                }}
                              >
                                <a>
                                  {isEmpty(window.lang["슬롯"])
                                    ? "슬롯"
                                    : window.lang["슬롯"]}
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div
                            id="prev"
                            display="false"
                            style={{ display: "none", cursor: "pointer" }}
                          >
                            {" "}
                            <a
                              id="prevArrow"
                              className="btnPrev"
                              langkey="new_theme.common.btn_prev"
                            >
                              이전
                            </a>{" "}
                          </div>
                          <div
                            id="next"
                            display="false"
                            style={{ display: "none", cursor: "pointer" }}
                          >
                            {" "}
                            <a
                              id="nextArrow"
                              className="btnNext"
                              langkey="new_theme.common.btn_next"
                            >
                              다음
                            </a>{" "}
                          </div>
                        </div>
                        <div className="tabContainer">
                          <div className="tabCon">
                            <ul className="eventList">
                              <div
                                className="swiper-container swiper-container-initialized swiper-container-horizontal"
                                id="swiper-event"
                              >
                                <div
                                  className="swiper-wrapper"
                                  style={{ transitionDuration: "0ms" }}
                                >
                                  {posts
                                    .filter((item) => item.type === eventType)
                                    .map((list, index) => {
                                      return (
                                        <div
                                          className="swiper-slide swiper-lazy pointer viewCategory_44"
                                          key={index}
                                        >
                                          <a href="http://localhost/event/detail/746">
                                            <span
                                              className="evtThumb"
                                              style={{
                                                display: "inline-block",
                                                height: "185px",
                                                width: "100%",
                                              }}
                                            >
                                              <img
                                                src={
                                                  resource_url +
                                                  "/images/events/" +
                                                  list.image
                                                }
                                                style={{
                                                  maxWidth: "386px",
                                                  maxHeight: " 186px",
                                                }}
                                                alt=""
                                              />
                                            </span>
                                            <p
                                              style={{
                                                width: "100%",
                                                marginTop: "10px",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: list.title,
                                              }}
                                            ></p>
                                          </a>
                                        </div>
                                      );
                                    })}
                                </div>
                                <span
                                  className="swiper-notification"
                                  aria-live="assertive"
                                  aria-atomic="true"
                                ></span>
                              </div>
                              <div
                                className="swiper-button-prev swiper-button-disabled"
                                id="swiper-event-prev"
                                role="button"
                                aria-label="Previous slide"
                                aria-disabled="true"
                                style={{ display: "none" }}
                              ></div>
                              <div
                                className="swiper-button-next swiper-button-disabled"
                                id="swiper-event-next"
                                role="button"
                                aria-label="Next slide"
                                aria-disabled="true"
                                style={{ display: "none" }}
                              ></div>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="layer_tutorial" id="tutorialWithdraw">
                {" "}
                <a className="bt_close" langkey="button.popup_close">
                  팝업닫기
                </a>
                <div className="inner">
                  <p className="txt_big" langkey="desc.welcomle_popup_b"></p>
                  <p className="txt" langkey="desc.welcome_popup_b_info">
                    게임을 통해 콤프도 적립받고
                    <br /> 베팅 수익금은 실시간으로
                    <br /> 출금 할 수 있습니다
                  </p>
                  <div className="bt_area">
                    {" "}
                    <a className="" langkey="button.direct_withdraw">
                      출금 페이지 바로가기
                    </a>{" "}
                  </div>
                </div>
              </div>
              <Footbar />
              <div
                className="bubble_pop_box"
                id="bubblePopBox"
                style={{ display: "block", right: "-198px" }}
              >
                <div className="bubble_pop_close"></div>
                <div className="bubble_pop">
                  <div className="bubble_pop_image">
                    <p
                      className="bubble_info_title"
                      langkey="desc.bubble_info_title"
                    >
                      간편 메뉴를 위아래로 움직여 보세요.
                    </p>
                    <p
                      className="bubble_info_content"
                      langkey="desc.bubble_info_content"
                    >
                      게임 플레이에 방해되지 않게
                      <br />
                      원하는 위치로 이동할 수 있습니다.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="cs_center ui-draggable ui-draggable-handle"
                id="csCenter"
                style={{ right: "-198px" }}
              >
                <a className="bt_cs is-login-quick" langkey="title.simple_menu">
                  간<br />편<br />메<br />뉴
                </a>
                <div className="cs_con">
                  <ul>
                    <li className="bt_cs1">
                      <Link to="/deposit">
                        <span
                          className=""
                          langkey="new_theme.common.btn_deposit"
                        >
                          {isEmpty(window.lang["입금"])
                            ? "입금"
                            : window.lang["입금"]}
                        </span>
                      </Link>
                    </li>
                    <li className="bt_cs2">
                      <Link to="/withdraw">
                        <span
                          className=""
                          langkey="new_theme.common.withdraw_money"
                        >
                          {isEmpty(window.lang["출금"])
                            ? "출금"
                            : window.lang["출금"]}
                        </span>
                      </Link>
                    </li>
                    <li className="bt_cs5">
                      <Link to="/mypage/history">
                        <span
                          className=""
                          langkey="new_theme.common.betting_details"
                        >
                          {isEmpty(window.lang["베팅내역"])
                            ? "베팅내역"
                            : window.lang["베팅내역"]}
                        </span>
                      </Link>
                    </li>
                    <li className="bt_cs4">
                      <Link to="/inquiries/question">
                        <span className="" langkey="new_theme.gnb.cscenter">
                          {isEmpty(window.lang["고객센터"])
                            ? "고객센터"
                            : window.lang["고객센터"]}
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <button className="btnGameDetailQuick" id="closeQuick">
                {" "}
                <img
                  src="/r/theme/center_logo/img/pc/arrow_down.png"
                  alt=""
                />{" "}
              </button>

              <div id="pageViewBox">
                {" "}
                <a
                  id="btnCloseIcoQuick"
                  className="bt_close_ico pointer"
                ></a>{" "}
              </div>
              <div id="pageView" className="pageView"></div>
              <div className="livechat">
                {" "}
                <a className="bt_chat">
                  <img
                    src="/r/front/img/comm/bt_livechat.png"
                    alt="LIVE CHAT"
                  />
                </a>{" "}
              </div>
            </div>
            <div id="temporary_spa_section" style={{ display: "none" }}></div>
            <div
              className="wrap_layer_popup_box"
              style={{ display: "none" }}
            ></div>
          </div>
          <div
            className=" align-items-center  justify-content-center slot-modal-back"
            style={{ display: !openModal ? "none" : "flex" }}
          >
            <div
              className="justify-content-center slot-modal game_list"
              style={{ listStyleType: "none" }}
            >
              <button
                data-v-57fde08a=""
                className="btn_close"
                onClick={onClickCloseModal}
              >
                <i
                  data-v-57fde08a=""
                  className="fa-light fa-close font-weight-light align-items-center justify-content-center color-white font-size-26 btn-close"
                  style={{ fontStyle: "normal" }}
                ></i>
              </button>
              <div className="slot-search ">
                {/* <label className="slot-search-label">검색</label> */}
                <input
                  className="slot-search-input "
                  name="search"
                  type="text"
                  placeholder={
                    isEmpty(window.lang["검색"]) ? "검색" : window.lang["검색"]
                  }
                  value={search}
                  onChange={onChange}
                />
              </div>
              <div className="w-100 h-100 overflow-auto">
                <ul
                  className="slot_list justify-content-center flex-wrap"
                  style={{ width: "100%" }}
                >
                  {gameLists
                    .filter((list) => {
                      const patt = new RegExp(search, "i");
                      return (
                        patt.test(getTitle(list, props.language)) ||
                        isEmpty(search)
                      );
                    })
                    .map((list, index) => {
                      const imgIndex = imgLists.findIndex(
                        (img) => img.src === list.image
                      );
                      return (
                        <li
                          key={index}
                          style={{
                            listStyleType: "none",
                            marginBottom: "30px_",
                          }}
                        >
                          <a
                            style={{ backgroundColor: "#0f1621" }}
                            onClick={() => onClickList(list)}
                          >
                            <img
                              data-v-3348b8aa=""
                              className="slot-default-img"
                              src={imgLists[imgIndex].src}
                              alt=""
                              style={{
                                borderRadius: "10%",
                                minWidth: "145px_",
                              }}
                            />
                          </a>
                          <p className="text-center" style={{ color: "white" }}>
                            {getTitle(list, props.language)}
                          </p>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

const MobileDashboard = (props) => {
  const { isAuthenticated, user, unreadNotes, casinoStatus, notices, more } =
    props;
  // const isAuthenticated  = props.user.isAuthenticated;
  const roomObj = {
    pageType: "toto",
    sportType: "sport",
    gameType: "live",
    sportId: "all",
    esportType: "all",
    sort: "time",
    location: "all",
    page: 1,
    perPage: 10,
  };

  const [casinoLists, setCasinoLists] = useState([]);
  const [slotLists, setSlotLists] = useState([]);

  const [showCasinos, setShowCasinos] = useState([]);
  const [showSlots, setShowSlots] = useState([]);
  const [showBestGames, setShowBestGames] = useState([]);

  const [gameLists, setGameLists] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [imgLists, setImgLists] = useState([]);
  const [showAllCasino, setShowAllCasino] = useState(false);
  const [showAllSlot, setShowAllSlot] = useState(false);
  const [showAllBestGame, setShowAllBestGame] = useState(false);
  const [search, setSearch] = useState("");
  const [eventType, setEventType] = useState("");

  const [isShowAllCasino, setIsShowAllcasino] = useState(false);
  const headerStyle = {
    position: "relative",
    top: "0px",
    left: "0px",
    width: "400px",
    height: "85px", // `!important`는 적용 불가
    boxShadow: "1px 5px 10px #0c0c0c",
    zIndex: "10", // 마지막 선언만 유지
    background:
      "linear-gradient(180deg, rgba(0, 0, 0, 0.20) 20%, rgba(0, 0, 0, 0.95) 50%, rgba(0, 0, 0, 0.3) 56%)",
    backgroundColor: "#333",
    borderTop: "1px solid #6a6a6a",
    borderBottom: "1px solid #6a6a6a",
    borderRadius: "4px",
  };

  const normalStyle = {
    height: "40px",
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setSearch(value);
  };

  const normalImage = "Logo.jpg";
  const gameType = "Slot";

  const onClickOpenModal = (list) => {
    if (!props.isAuthenticated)
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    props.SetPageLoading(true);
    setGameLists([]);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      vendor: list.vendor,
      // api: api
    };

    getGameList(params).then((data) => {
      // setApi(data.api);
      getImages(data.result, data.api).then((images) => {
        setImgLists(images);
        setGameLists(data.result);
        setOpenModal(!openModal);
        props.SetPageLoading(false);
      });
    });
  };

  const onClickList = (list) => {
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: gameType,
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  const posts = more.event.posts;

  useEffect(() => {}, [eventType]);

  const onClickCloseModal = (list) => {
    // console.log(list);
    setOpenModal(!openModal);
  };

  const getModalImg = (e) => {
    e.target.src = `../images/${gameType}/${normalImage}`;
  };

  const getLists = (type) => {
    const params = {
      type: type,
    };
    getLoginLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
    });
  };

  const getLoginLists = (type) => {
    props.SetPageLoading(true);
    const params = {
      type: type,
      token: user.loginId,
      username: user.loginId,
      status: casinoStatus,
    };
    getLobbylist(params).then((data) => {
      if (type == "casino") {
        setCasinoLists(data.lobbyList);
      } else if (type == "Slot") {
        setSlotLists(data.lobbyList);
      }
      props.SetPageLoading(false);
    });
  };

  const onClickCasino = (list, event) => {
    event.preventDefault();
    if (!isAuthenticated) {
      toastr.warning(
        isEmpty(window.lang["로그인하시고 이용해주세요."])
          ? "로그인하시고 이용해주세요."
          : window.lang["로그인하시고 이용해주세요."]
      );
      return;
    }
    props.SetPageLoading(true);
    // console.log(localStorage);
    const params = {
      ...list,
      type: "casino",
      username: user.loginId,
      ipADD: localStorage.getItem("client-ip"),
    };
    getGameLaunch(params);
  };

  useEffect(() => {
    if (showAllCasino == false) {
      setShowCasinos(casinoLists.slice(0, 6));
    } else {
      setShowCasinos(casinoLists);
    }
  }, [showAllCasino, casinoLists]);

  useEffect(() => {
    if (showAllSlot == false) {
      setShowSlots(slotLists.slice(0, 6));
    } else {
      setShowSlots(slotLists);
    }
  }, [showAllSlot, slotLists]);

  useEffect(() => {
    if (showAllBestGame == false) {
      setShowBestGames(slotLists.slice(0, 6));
    } else {
      setShowBestGames(slotLists);
    }
  }, [showAllBestGame, slotLists]);

  let gamelists = [],
    depositlists = [],
    withdrawlists = [];

  gamelists = props.sports.data;

  depositlists = props.more.realDeposite.data;
  withdrawlists = props.more.realWithdraw.data;

  useEffect(() => {
    const roomObj = {
      pageType: "toto",
      sportType: "sport",
      gameType: "live",
      sportId: "all",
      esportType: "all",
      sort: "time",
      location: "all",
      page: 1,
      perPage: 10,
    };

    props.GetDashboardSportsList(roomObj);

    if (props.user.isAuthenticated) getLists(1);
    new window.Swiper({
      el: ".main_best_list",
      slidesPerView: 5, //레이아웃 뷰 개수
      spaceBetween: 25, // 슬라이드 사이 여백
      centeredSlides: true, //센터모드
      loop: true, // 슬라이드 반복 여부
      autoplay: true,
      loopAdditionalSlides: 1, // 슬라이드 반복 시 마지막 슬라이드에서 다음 슬라이드가 보여지지 않는 현상 수정
      slideToClickedSlide: true, // 해당 슬라이드 클릭시 슬라이드 위치로 이동
      initialSlide: 0,
      grabCursor: false,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      mousewheel: {
        enabled: false,
      },
      keyboard: {
        enabled: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // 1024: {
        //     slidesPerView: 5
        // },
        // 520: {
        //     slidesPerView: 1
        // }
      },
    });
  }, []);

  const [day, setDay] = useState("");

  const getDay = () => {
    setInterval(() => {
      let time = new Date();
      setDay(dateFormation(time));
    }, 1000);
  };
  // useEffect(()=>{
  //     getDay();
  // });

  useEffect(() => {
    // visual();
    let time = new Date();
    // setDay( dateFormation(time));
    $("#slide_time").html(dateFormation(time));
    setInterval(() => {
      let time = new Date();
      // setDay( dateFormation(time));
      $("#slide_time").html(dateFormation(time));
    }, 1000);
  }, []);

  useEffect(() => {
    if (window.$) {
      // Initialize the tableTicker plugin when the component mounts
      // $(window).on("load", () => {
      // window.$(".oneRowTicker").oneRowTicker({
      //   speed: 500,
      //   interval: 3000,
      // });
      // window.$("#myTable3").tableTicker({
      //   row: 2,
      //   speed: 2000,
      //   interval: 2000,
      //   buffer: 0,
      //   complete: function () {
      //     $("#cnt").html(this.rolled);
      //   },
      // });
      // });
    }
  }, []);

  useEffect(() => {
    props.GetRealTimeExchangeData(1);
    props.GetRealTimeExchangeData(-1);

    const depositeInterval = setInterval(
      props.GetRealTimeExchangeData(1),
      150000
    );
    const withdrawInterval = setInterval(
      props.GetRealTimeExchangeData(-1),
      150000
    );

    return () => {
      clearInterval(depositeInterval);
      clearInterval(withdrawInterval);
    };
  }, []);

  useEffect(() => {
    props.GetEventList({ page: 1, perPage: 10, type: "" });
    if (isAuthenticated) {
      getLoginLists("casino");
      props.GetNoticeList({ page: 1, perPage: 10 });
      getLoginLists("Slot");
    } else {
      getLists("casino");
      props.GetLoginNoticeList({ page: 1, perPage: 10 });
      getLists("Slot");
    }
  }, [isAuthenticated]);

  const onClickMemMenu = (e) => {
    if (!isAuthenticated) {
      e.preventDefault();
      toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
  };

  const onClickImg = (e, url) => {
    if (!isAuthenticated) {
      e.preventDefault();
      return toastr.warning(
        `${
          isEmpty(window.lang["로그인하시고 이용해주세요."])
            ? "로그인하시고 이용해주세요."
            : window.lang["로그인하시고 이용해주세요."]
        }`
      );
    }
    window.location.href = url;
  };

  return (
    <Fragment>
      <div id="layoutBody" style={{ paddingTop: "0px" }}>
        <div className="wrapper  lang_ko" id="bodyTemplate">
          <Headbar />
          <div className="container-fluid main_section">
            <div
              id="theme_banner_outer"
              style={{ paddingTop: 0, marginLeft: -15, marginRight: -15 }}
            >
              <div id="theme_banner_check" style={{ visibility: "visible" }}>
                <div
                  className="swiper-container snb_sl swiper-container-initialized swiper-container-horizontal"
                  id="swiper-head0"
                >
                  <div
                    id="demo"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <ul className="carousel-indicators">
                      <li
                        data-target="#demo"
                        data-slide-to="0"
                        className="active"
                        style={{ width: 10, height: 10 }}
                      ></li>
                      <li
                        data-target="#demo"
                        data-slide-to="1"
                        style={{ width: 10, height: 10 }}
                      ></li>
                      <li
                        data-target="#demo"
                        data-slide-to="2"
                        style={{ width: 10, height: 10 }}
                      ></li>
                      <li
                        data-target="#demo"
                        data-slide-to="3"
                        style={{ width: 10, height: 10 }}
                      ></li>
                      <li
                        data-target="#demo"
                        data-slide-to="4"
                        style={{ width: 10, height: 10 }}
                      ></li>
                    </ul>

                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <img
                          src="../images/banners/mobile/1.webp"
                          alt="Chicago"
                          className="h-100"
                          data-seq="1883"
                          onClick={(e) => onClickImg(e, "/casino")}
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          src="../images/banners/mobile/2.webp"
                          alt="Chicago"
                          className="h-100"
                          onClick={(e) => onClickImg(e, "/sportslive")}
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          src="../images/banners/mobile/3.webp"
                          alt="New York"
                          className="h-100"
                          onClick={(e) => onClickImg(e, "/Slot")}
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          src="../images/banners/mobile/4.webp"
                          alt="New York"
                          className="h-100"
                          onClick={(e) => onClickImg(e, "/sportsprematch")}
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          src="../images/banners/mobile/5.webp"
                          alt="New York"
                          className="h-100"
                          onClick={(e) => onClickImg(e, "/minigame")}
                        />
                      </div>
                    </div>

                    <a href="#demo" data-slide="prev">
                      <div
                        className="swiper-button-prev"
                        role="button"
                        aria-label="Previous slide"
                      ></div>
                    </a>
                    <a href="#demo" data-slide="next">
                      <div
                        className="swiper-button-next"
                        role="button"
                        aria-label="Next slide"
                      ></div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="contents">
              <div className="quick-main">
                <ul>
                  <li className="sports">
                    <a data-href="/game/newDetail/0?gamecode=66&amp;game_child_seq=13143&amp;event=N&amp;type=sports">
                      <img
                        src="/r/theme/center_logo/img/pc/img_main_q_sports.png"
                        alt="스포츠"
                      />
                    </a>
                  </li>
                  <li className="casino">
                    <a data-href="/game/main/10588">
                      <img
                        src="/r/theme/center_logo/img/pc/img_main_q_casino.png"
                        alt="카지노"
                      />
                    </a>
                  </li>
                  <li className="evolution">
                    <a data-href="/game/casino/detail/0?gamecode=12&amp;game_child_seq=18403&amp;event=N">
                      <img
                        src="/r/theme/center_logo/img/pc/img_main_q_evolution.png"
                        alt="에볼루션"
                      />
                    </a>
                  </li>
                  <li className="minigame">
                    <a data-href="/game/newDetail/0?gamecode=71021&amp;game_child_seq=21366">
                      <img
                        src="/r/theme/center_logo/img/pc/img_main_q_minigame.png"
                        alt="미니게임"
                      />
                    </a>
                  </li>
                  <li className="slot">
                    <a data-href="/game/main/10558">
                      <img
                        src="/r/theme/center_logo/img/pc/img_main_q_slotgame.png"
                        alt="슬롯"
                      />
                    </a>
                  </li>
                  <li className="event">
                    <a>
                      <img
                        src="/r/theme/center_logo/img/pc/img_main_q_event.png"
                        alt="이벤트"
                      />
                    </a>
                  </li>
                </ul>
              </div>
              <div id="gameList">
                <div className="game_list1" id="category2289">
                  <div className="sport inner">
                    <div className="titlebox">
                      <h4>
                        {isEmpty(window.lang["라이브카지노"])
                          ? "라이브카지노"
                          : window.lang["라이브카지노"]}{" "}
                      </h4>
                      <a
                        className="bt_all pointer simple  "
                        id="bt_all_2289"
                        data-category-seq="category2289"
                        data-seq="0"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          border: "none",
                          fontSize: 30,
                        }}
                        onClick={() => setShowAllCasino(!showAllCasino)}
                      >
                        <i
                          class={`fas fa-${showAllCasino ? "minus" : "plus"}`}
                        ></i>
                      </a>
                    </div>
                    <div className="game_list_wrap" data-cat="2289">
                      <ul
                        className={showAllCasino ? "row" : "d-flex"}
                        style={{ overflowX: "scroll" }}
                      >
                        {showCasinos.map((list, index) =>
                          showAllCasino ? (
                            <li
                              className="col-6 col-md-2 col-sm-3 fade-in"
                              key={index}
                              data-move-url="/game/casino/detail/0?gamecode=12&amp;game_child_seq=3602&amp;event=N"
                              data-game-title="코리안 딜러 스피드 바카라"
                              data-game-title-en="Korean Speed Baccarat"
                              data-game-code="12"
                              data-game-meta-code="npn3y3hkld2mcdjt"
                              data-game-description="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                              data-game-video-url="c309b3d6f89ecc3395a96a02ca12a60e"
                              data-event_game_yn="N"
                              data-game-child-seq="3602"
                              onClick={(e) => {
                                onClickCasino(list, e);
                              }}
                            >
                              <span
                                className="G005001"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                  style={{
                                    backgroundImage:
                                      "url('images/upload/mobile/ico_info_wh.png')",
                                    backgroundSize: "contain",
                                    width: 25,
                                    height: 25,
                                    zIndex: 1111,
                                    right: 30,
                                    top: 15,
                                    position: "absolute",
                                  }}
                                ></div>
                              </span>
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0823/L6tP_zGpX_DGVE_qwOf.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 40,
                                }}
                              >
                                <p
                                  className="gameTitle"
                                  style={{
                                    padding: 10,
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                              </div>
                            </li>
                          ) : (
                            <li
                              className="col-4 p-0"
                              key={index}
                              data-move-url="/game/casino/detail/0?gamecode=12&amp;game_child_seq=3602&amp;event=N"
                              data-game-title="코리안 딜러 스피드 바카라"
                              data-game-title-en="Korean Speed Baccarat"
                              data-game-code="12"
                              data-game-meta-code="npn3y3hkld2mcdjt"
                              data-game-description="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                              data-game-video-url="c309b3d6f89ecc3395a96a02ca12a60e"
                              data-event_game_yn="N"
                              data-game-child-seq="3602"
                              onClick={(e) => {
                                onClickCasino(list, e);
                              }}
                              style={{
                                marginRight: !showAllSlot && "5px",
                              }}
                            >
                              <span
                                className="G005001"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                  style={{
                                    backgroundImage:
                                      "url('images/upload/mobile/ico_info_wh.png')",
                                    backgroundSize: "contain",
                                    width: 25,
                                    height: 25,
                                    zIndex: 1111,
                                    right: 10,
                                    top: 15,
                                    position: "absolute",
                                  }}
                                ></div>
                              </span>
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0823/L6tP_zGpX_DGVE_qwOf.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                  aspectRatio: "1 / 1 !important",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 40,
                                }}
                              >
                                <p
                                  className="gameTitle"
                                  style={{
                                    padding: 10,
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="game_list1" id="category1830">
                  <div className="sport inner">
                    <div className="titlebox">
                      <h4>
                        {isEmpty(window.lang["슬롯"])
                          ? "슬롯"
                          : window.lang["슬롯"]}{" "}
                      </h4>
                      <a
                        className="bt_all pointer simple  "
                        id="bt_all_1830"
                        data-category-seq="category1830"
                        data-seq="2"
                        onClick={() => setShowAllSlot(!showAllSlot)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          border: "none",
                          fontSize: 30,
                        }}
                      >
                        <i
                          class={`fas fa-${showAllSlot ? "minus" : "plus"}`}
                        ></i>
                      </a>
                    </div>
                    <div className="game_list_wrap" data-cat="1830">
                      <ul
                        className={showAllSlot ? "row" : "d-flex mr-2"}
                        style={{ overflowX: "scroll" }}
                      >
                        {showSlots.map((list, index) =>
                          showAllSlot ? (
                            <li
                              className="col-6 col-md-2 col-sm-3"
                              key={index}
                              data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                              data-game-title="빅 배스 보난자"
                              data-game-title-en="Big Bass Bonanza"
                              data-game-code="28"
                              data-game-meta-code="244"
                              data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                              data-game-video-url=""
                              data-event_game_yn="N"
                              data-game-child-seq="11605"
                              onClick={() => onClickOpenModal(list)}
                            >
                              {" "}
                              <span
                                className="G005001"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                  style={{
                                    backgroundImage:
                                      "url('images/upload/mobile/ico_info_wh.png')",
                                    backgroundSize: "contain",
                                    width: 25,
                                    height: 25,
                                    zIndex: 1111,
                                    right: 30,
                                    top: 15,
                                    position: "absolute",
                                  }}
                                ></div>
                              </span>
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 40,
                                }}
                              >
                                <p
                                  className="gameTitle"
                                  style={{
                                    padding: 10,
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                              </div>
                              <div
                                className="layer_item_set"
                                style={{
                                  top: "1px",
                                  left: "1px",
                                  display: "none",
                                }}
                              >
                                <div className="thumb" id="test22">
                                  {" "}
                                  <a
                                    style={{
                                      background:
                                        "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                      backgroundSize: "100%",
                                    }}
                                  >
                                    <img
                                      src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                      style={{
                                        width: "218px",
                                        height: "218px",
                                      }}
                                      className="item_img"
                                    />{" "}
                                  </a>
                                </div>
                                <div
                                  className="gameLinkArea"
                                  data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-new-window=""
                                ></div>
                              </div>
                            </li>
                          ) : (
                            <li
                              className="col-4 p-0"
                              key={index}
                              data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                              data-game-title="빅 배스 보난자"
                              data-game-title-en="Big Bass Bonanza"
                              data-game-code="28"
                              data-game-meta-code="244"
                              data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                              data-game-video-url=""
                              data-event_game_yn="N"
                              data-game-child-seq="11605"
                              onClick={() => onClickOpenModal(list)}
                              style={{
                                marginRight: !showAllSlot && "5px",
                              }}
                            >
                              {" "}
                              <span className="G005001">
                                <div
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                  style={{
                                    backgroundImage:
                                      "url('images/upload/mobile/ico_info_wh.png')",
                                    backgroundSize: "contain",
                                    width: 25,
                                    height: 25,
                                    zIndex: 1111,
                                    right: 10,
                                    top: 15,
                                    position: "absolute",
                                  }}
                                ></div>
                              </span>{" "}
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                  aspectRatio: "1 / 1 !important",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 40,
                                }}
                              >
                                <p className="gameTitle">
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                              </div>
                              <div
                                className="layer_item_set"
                                style={{
                                  top: "1px",
                                  left: "1px",
                                  display: "none",
                                }}
                              >
                                <div className="thumb" id="test22">
                                  {" "}
                                  <a
                                    style={{
                                      background:
                                        "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                      backgroundSize: "100%",
                                    }}
                                  >
                                    <img
                                      src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                      style={{
                                        width: "218px",
                                        height: "218px",
                                      }}
                                      className="item_img"
                                    />{" "}
                                  </a>
                                </div>
                                <div
                                  className="gameLinkArea"
                                  data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-new-window=""
                                ></div>
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="game_list1" id="category1830">
                  <div className="sport inner">
                    <div className="titlebox">
                      <h4>
                        {isEmpty(window.lang["베스트게임"])
                          ? "베스트게임"
                          : window.lang["베스트게임"]}{" "}
                      </h4>
                      <a
                        className="bt_all pointer simple  "
                        id="bt_all_1830"
                        data-category-seq="category1830"
                        data-seq="2"
                        onClick={() => setShowAllBestGame(!showAllBestGame)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          border: "none",
                          fontSize: 30,
                        }}
                      >
                        <i
                          class={`fas fa-${showAllBestGame ? "minus" : "plus"}`}
                        ></i>
                      </a>
                    </div>
                    <div className="game_list_wrap" data-cat="1830">
                      <ul
                        className={showAllBestGame ? "row" : "d-flex mr-2"}
                        style={{ overflowX: "scroll" }}
                      >
                        {showBestGames.map((list, index) =>
                          showAllBestGame ? (
                            <li
                              className="col-6 col-md-2 col-sm-3"
                              key={index}
                              data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                              data-game-title="빅 배스 보난자"
                              data-game-title-en="Big Bass Bonanza"
                              data-game-code="28"
                              data-game-meta-code="244"
                              data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                              data-game-video-url=""
                              data-event_game_yn="N"
                              data-game-child-seq="11605"
                              onClick={() => onClickOpenModal(list)}
                            >
                              {" "}
                              <span
                                className="G005001"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                  style={{
                                    backgroundImage:
                                      "url('images/upload/mobile/ico_info_wh.png')",
                                    backgroundSize: "contain",
                                    width: 25,
                                    height: 25,
                                    zIndex: 1111,
                                    right: 30,
                                    top: 15,
                                    position: "absolute",
                                  }}
                                ></div>
                              </span>
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 40,
                                }}
                              >
                                <p
                                  className="gameTitle"
                                  style={{
                                    padding: 10,
                                    justifyContent: "flex-start",
                                  }}
                                >
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                              </div>
                              <div
                                className="layer_item_set"
                                style={{
                                  top: "1px",
                                  left: "1px",
                                  display: "none",
                                }}
                              >
                                <div className="thumb" id="test22">
                                  {" "}
                                  <a
                                    style={{
                                      background:
                                        "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                      backgroundSize: "100%",
                                    }}
                                  >
                                    <img
                                      src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                      style={{
                                        width: "218px",
                                        height: "218px",
                                      }}
                                      className="item_img"
                                    />{" "}
                                  </a>
                                </div>
                                <div
                                  className="gameLinkArea"
                                  data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-new-window=""
                                ></div>
                              </div>
                            </li>
                          ) : (
                            <li
                              className="col-4 p-0"
                              key={index}
                              data-move-url="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                              data-game-title="빅 배스 보난자"
                              data-game-title-en="Big Bass Bonanza"
                              data-game-code="28"
                              data-game-meta-code="244"
                              data-game-description="배스 낚시를 소재로 디자인되었으며,	5X3열 10개의 페이라인을 가진 슬롯 게임		RTP : 96.71%	프리스핀 : 제공	최대 당첨 배수 : 2,100배"
                              data-game-video-url=""
                              data-event_game_yn="N"
                              data-game-child-seq="11605"
                              onClick={() => onClickOpenModal(list)}
                              style={{
                                marginRight: !showAllBestGame && "5px",
                              }}
                            >
                              {" "}
                              <span className="G005001">
                                <div
                                  className="gameDetailInfo"
                                  data-game-name="코리안 딜러 스피드 바카라"
                                  data-game-detail="운영시간 안내 : 14:00 - 07:00	베팅금 : 최소 1,000 - 최대 100,000,000		베팅 시간이 짧고 카드 확인하는 시간 없이 바로 오픈하는게 특징	한국인 라이브 딜러에 의해 게임이 진행되는 코리안 스피드 바카라"
                                  langkey="col.reminders"
                                  style={{
                                    backgroundImage:
                                      "url('images/upload/mobile/ico_info_wh.png')",
                                    backgroundSize: "contain",
                                    width: 25,
                                    height: 25,
                                    zIndex: 1111,
                                    right: 10,
                                    top: 15,
                                    position: "absolute",
                                  }}
                                ></div>
                              </span>{" "}
                              <img
                                className="videoPosterImages"
                                video-seq="0"
                                data-original="/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?306x306c"
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  objectFit: "cover",
                                  aspectRatio: "1 / 1 !important",
                                }}
                                src={getlistImgPath(list)}
                              />
                              <div
                                className="gameInfo"
                                style={{
                                  height: 40,
                                }}
                              >
                                <p className="gameTitle">
                                  {" "}
                                  {getTitle(list, props.language)}{" "}
                                </p>{" "}
                              </div>
                              <div
                                className="layer_item_set"
                                style={{
                                  top: "1px",
                                  left: "1px",
                                  display: "none",
                                }}
                              >
                                <div className="thumb" id="test22">
                                  {" "}
                                  <a
                                    style={{
                                      background:
                                        "url('/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png') no-repeat",
                                      backgroundSize: "100%",
                                    }}
                                  >
                                    <img
                                      src="../images/upload/2021/0121/EcwI_e7XR_YV3p_Sxqd.png?218x218c"
                                      style={{
                                        width: "218px",
                                        height: "218px",
                                      }}
                                      className="item_img"
                                    />{" "}
                                  </a>
                                </div>
                                <div
                                  className="gameLinkArea"
                                  data-href="/game/slot/detail/0?gamecode=28&amp;game_child_seq=11605&amp;event=N"
                                  data-new-window=""
                                ></div>
                              </div>
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mainEvent" id="mainEventArea">
                <div id="theme_event">
                  <div className="inner">
                    <div className="titlebox addTab">
                      <h4 className="" langkey="new_theme.common.event">
                        {isEmpty(window.lang["이벤트"])
                          ? "이벤트"
                          : window.lang["이벤트"]}
                      </h4>
                      <div className="main_event_area"></div>
                      <div
                        id="prev"
                        display="false"
                        style={{ display: "none", cursor: "pointer" }}
                      >
                        <a
                          id="prevArrow"
                          className="btnPrev"
                          langkey="new_theme.common.btn_prev"
                        >
                          이전
                        </a>{" "}
                      </div>
                      <div
                        id="next"
                        display="false"
                        style={{ display: "none", cursor: "pointer" }}
                      >
                        {" "}
                        <a
                          id="nextArrow"
                          className="btnNext"
                          langkey="new_theme.common.btn_next"
                        >
                          다음
                        </a>{" "}
                      </div>
                    </div>
                    <div className="tabContainer">
                      <div className="tabCon">
                        <ul className="eventList">
                          <div
                            className="swiper-container swiper-container-initialized swiper-container-horizontal"
                            id="swiper-event"
                          >
                            <div
                              className="swiper-wrapper"
                              style={{ transitionDuration: "0ms" }}
                            ></div>
                            <span
                              className="swiper-notification"
                              aria-live="assertive"
                              aria-atomic="true"
                            ></span>
                            <ul
                              className="carousel-indicators"
                              style={{ bottom: "25px" }}
                            >
                              {posts
                                .filter((item) => item.type === eventType)
                                .map((list, index) => (
                                  <li
                                    key={index}
                                    data-target="#demo"
                                    data-slide-to={index}
                                    style={{ width: 10, height: 10 }}
                                  ></li>
                                ))}
                            </ul>
                            <div
                              className="carousel-inner"
                              style={{ height: "200px" }}
                            >
                              {posts
                                .filter((item) => item.type === eventType)
                                .map((list, index) => {
                                  return (
                                    <div
                                      className="carousel-item active"
                                      key={index}
                                    >
                                      <a href="#">
                                        <span
                                          className="evtThumb"
                                          style={{
                                            display: "inline-block",
                                            height: "185px",
                                            width: "100%",
                                          }}
                                        >
                                          <img
                                            src={
                                              resource_url +
                                              "/images/events/" +
                                              list.image
                                            }
                                            style={{
                                              maxWidth: "386px",
                                              maxHeight: " 186px",
                                            }}
                                            alt=""
                                          />
                                        </span>
                                        <p
                                          style={{
                                            width: "100%",
                                            marginTop: "-10px",
                                            textAlign: "center",
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: list.title,
                                          }}
                                        ></p>
                                      </a>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                          <div
                            className="swiper-button-prev swiper-button-disabled"
                            id="swiper-event-prev"
                            role="button"
                            aria-label="Previous slide"
                            aria-disabled="true"
                            style={{ left: 10 }}
                          ></div>
                          <div
                            className="swiper-button-next swiper-button-disabled"
                            id="swiper-event-next"
                            role="button"
                            aria-label="Next slide"
                            aria-disabled="true"
                            style={{ right: 10 }}
                          ></div>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMobile() ? <MobileFootbar /> : <Footbar />}{" "}
        </div>
        <div className="">
          <div>
            <OneRowTablePicker
              data={interleaveArrays(withdrawlists, depositlists)}
              interval={3000}
              speed={1500}
            />
          </div>
        </div>
      </div>
      <div
        className=" align-items-center  justify-content-center slot-modal-back"
        style={{ display: !openModal ? "none" : "flex" }}
      >
        <div
          className="justify-content-center slot-modal game_list"
          style={{ listStyleType: "none" }}
        >
          <button
            data-v-57fde08a=""
            className="btn_close"
            onClick={onClickCloseModal}
          >
            <i
              data-v-57fde08a=""
              className="fa-light fa-close font-weight-light align-items-center justify-content-center color-white font-size-26 btn-close"
              style={{ fontStyle: "normal" }}
            ></i>
          </button>
          <div className="slot-search ">
            {/* <label className="slot-search-label">검색</label> */}
            <input
              className="slot-search-input "
              name="search"
              type="text"
              placeholder={
                isEmpty(window.lang["검색"]) ? "검색" : window.lang["검색"]
              }
              value={search}
              onChange={onChange}
            />
          </div>
          <div className="w-100 h-100 overflow-auto">
            <ul
              className="slot_list justify-content-center flex-wrap"
              style={{ width: "100%" }}
            >
              {gameLists
                .filter((list) => {
                  const patt = new RegExp(search, "i");
                  return (
                    patt.test(getTitle(list, props.language)) || isEmpty(search)
                  );
                })
                .map((list, index) => {
                  const imgIndex = imgLists.findIndex(
                    (img) => img.src === list.image
                  );
                  return (
                    <li
                      key={index}
                      style={{
                        listStyleType: "none",
                        marginBottom: "30px_",
                      }}
                    >
                      <a
                        style={{ backgroundColor: "#0f1621" }}
                        onClick={() => onClickList(list)}
                      >
                        <img
                          data-v-3348b8aa=""
                          className="slot-default-img"
                          src={imgLists[imgIndex].src}
                          alt=""
                          style={{
                            borderRadius: "10%",
                            minWidth: "145px_",
                          }}
                        />
                      </a>
                      <p className="text-center" style={{ color: "white" }}>
                        {getTitle(list, props.language)}
                      </p>
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  deposit: state.more.deposit,
  withdraw: state.more.withdraw,
  sports: state.sports,
  page: state.page,
  more: state.more,
  isAuthenticated: state.user.isAuthenticated,
  language: state.more.language,
  user: state.user.data,
  slideBar: state.more.slideBar,
  unreadNotes: state.more.message.unreadNotes,
  notices: state.more.notice.notices,
});

export default connect(mapStateToProps, {
  GetWithDrawList,
  GetDepositList,
  SetPageInfo,
  GetSportsList,
  GetDashboardSportsList,
  GetRealTimeExchangeData,
  GetNoticeList,
  GetLoginNoticeList,
  SetPageLoading,
  GetEventList,
})(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Sports/Main.js